function Card(props) {
  const { variant, extra, children, ...rest } = props;
  return (
    <div
      className={`!z-5 relative flex flex-col rounded-[20px] border border-gray-100 bg-white bg-clip-border shadow-card transition-all duration-300 ease-out hover:shadow-card-hover dark:border-white/5 dark:!bg-navy-800 dark:text-white dark:shadow-none dark:hover:shadow-none ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
